import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { RowTwoColumns } from "../common/formLayout";
import InputSelect from "../common/inputSelect";
import InputTextArea from "./../common/inputTextArea";
import { getStorages } from "../../services/entityService";
import { getCustomers } from "../../services/entityService";

const HeaderShipment = () => {
  const [storages, setStorages] = useState([]);
  const [customers, setCustomers] = useState([]);
  const { setValue } = useFormContext();

  useEffect(() => {
    const populateStorages = async () => {
      const { data } = await getStorages();
      const mapped = data.map((s) => {
        return { value: s._id, label: s.title };
      });
      if (mapped) setStorages(mapped);
    };
    populateStorages();
    return () => {
      setStorages([]);
    };
  }, []);

  useEffect(() => {
    const populateCustomers = async () => {
      const { data } = await getCustomers();
      const mapped = data.map((s) => {
        return { value: s._id, label: s.title };
      });
      if (mapped) setCustomers(mapped);
    };
    populateCustomers();
    return () => {
      setCustomers([]);
    };
  }, []);

  const handleSelect = (name, selected) => {
    setValue(selected.name, { value: name.value, label: name.label });
  };

  return (
    <>
      <RowTwoColumns
        colOne={
          <InputSelect
            name="locationFrom"
            label="From storage"
            options={storages}
            onChange={handleSelect}
            valueOption="value"
            labelOption="label"
          />
        }
        colTwo={
          <InputSelect
            name="name"
            label="To customer"
            options={customers}
            onChange={handleSelect}
            valueOption="value"
            labelOption="label"
          />
        }
      />
      <RowTwoColumns
        colOne={<InputTextArea name="addressFrom" label="From address" />}
        colTwo={<InputTextArea name="addressTo" label="To address" />}
      />
    </>
  );
};

export default HeaderShipment;
